import { render } from "./CZPositionReports.vue?vue&type=template&id=62e8d15c&ts=true"
import script from "./CZPositionReports.vue?vue&type=script&lang=ts"
export * from "./CZPositionReports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__